
import {Component, Prop, Vue} from "vue-property-decorator";
import {getRequest} from "../../../services/auth-service";
import PazLoader from "../../../components/utils/PazLoader.vue";
import Popup from "../Popup.vue";


@Component({
  components: {Popup, PazLoader}
})
export default class HtmlInput extends Vue {
  @Prop({})
  protected innerHtml!: any;

  @Prop({default: false})
  protected properties!: { html: {}, readonly?: boolean, disabled?: boolean, options?: object, axios?: boolean };

  @Prop()
  protected path!: string;

  protected readonly: boolean = false;
  protected disabled: boolean = false;
  protected html: object = {};
  protected isLoading: boolean = false;
  protected showPopup: boolean = false;
  protected popup: { color: string, code: number, message: string, timeout?: number };
  protected htmlContent: any;

  mounted() {
    if (this.properties.readonly) {
      this.readonly = this.properties.readonly;
    }

    this.html = this.properties.html;

    //fill the div with content.
    this.htmlContent = this.innerHtml;
    this.setInnerHtml();

    //just do it. #nike
    this.setLinks();
  }

  //might be overused in initial setup since it binds it twiche
  updated() {
    //re-add onclick event
    this.setLinks()
  }

  setLinks() {
    if (document.getElementById(this.path) && document.getElementById(this.path)!.getElementsByClassName('axios-request-item').length > 0) {
      let items = document.getElementsByClassName('axios-request-item');
      for (let item of items) {   //foreach item in HTML collection.
        this.setClickEvent(item)
      }
    }
  }

  setInnerHtml() {
    //get element
    let el: HTMLElement = document.getElementById(this.path)

    //set inner html
    el.innerHTML = this.htmlContent;
  }

  clearInnerHtml() {
    //get element
    let el: HTMLElement = document.getElementById(this.path)

    //set inner html to nothing
    el.innerHTML = '';
  }

  setClickEvent(item) {
    let dataset = item.dataset;         //get data attributes
    let url = dataset.requesturl;       //get the url stored in data attribute
    let refresh = dataset.refreshurl || false;
    //add onclick event for item
    item.addEventListener('click', () => {
      this.doGetRequest(url, refresh);
    });
  }

  async doGetRequest(url: string, refresh: string | boolean) {
    //clear old
    this.clearInnerHtml();

    //enable loading
    this.isLoading = true;

    //do request.
    let response = (await getRequest(url));

    //check status/ show popup.
    this.responseHandler(response)

    //redefine innerHtml.
    this.htmlContent = response.data.data;

    //fill inner html
    await this.setInnerHtml();

    if (refresh) {
      window.location.reload();
    }

    //disable loading.
    this.isLoading = false;
  }

  responseHandler(response) {
    if (!response.status) {
      this.popup = {
        color: 'error',
        code: 500,
        message: 'Response not defined!',
      }
      this.showPopup = true;
      // console.log('no response status')
      return;
    }

    switch (response.status) {
      case 200: {
        this.popup = {
          color: 'success',
          code: 200,
          message: 'successfully updated.',
        }
        break;
      }
      case 400 : {
        this.popup = {
          color: 'warning',
          code: 400,
          message: 'Error during update.',
        }
        break;
      }
      case 500: {
        this.popup = {
          color: 'error',
          code: 500,
          message: 'Server side error',
        }
        break;
      }
      default: {
        this.popup = {
          color: 'error',
          code: 500,
          message: 'Unknown error',
        }
        break;
      }
    }

    this.showPopup = true;

    return;
  }
}
